import React from 'react';
import {withStyles} from "@material-ui/core";
import Layout from '../../components/Layout';
import i18n from '../../i18n';
import QualificationsGrid from "../../components/Qualifications/QualificationsGrid";
import Toolbar from "../../components/Toolbar/Toolbar";

const QualificationsIndex = ({classes, qualifications}) => (
    <Layout>
        <Toolbar
            disableGutters
            title={ i18n.get('qualifications.heading_qualifications')}
            subtitle={`${qualifications.length} ${i18n.get('qualifications.number_of_qualifications')}`}
            items={[
                {
                    icon: 'add',
                    text: i18n.get('qualifications.new_qualification'),
                    href: `/qualifications/create`,
                }
            ]}
        />

        <QualificationsGrid qualifications={qualifications} />
    </Layout>
);

const styles = theme => ({
    paper: {
        marginTop: theme.spacing.unit * 3,
        marginBottom: theme.spacing.unit * 3,
        padding: theme.spacing.unit * 2,
        [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
            marginTop: theme.spacing.unit * 6,
            marginBottom: theme.spacing.unit * 6,
            padding: theme.spacing.unit * 3,
        },
    },
});

export default withStyles(styles)(QualificationsIndex);



// WEBPACK FOOTER //
// ./resources/assets/js/pages/qualifications/Index.jsx